import { render, staticRenderFns } from "./UpdatePlatformModal.vue?vue&type=template&id=7c466b6d"
import script from "./UpdatePlatformModal.vue?vue&type=script&lang=js"
export * from "./UpdatePlatformModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports